module.exports = __webpack_public_path__ + "static/matt-297ae3058324e3cc3b3791b43834577a.png";